export default {
  // Hero
  bizHeroTag: "Opportunités d'Investissement",
  bizHeroTitle1: "Investissement &",
  bizHeroTitle2: "Opportunités Commerciales",
  bizHeroDesc: "De l'incorporation d'entreprise aux opportunités d'investissement triées sur le volet en Afrique de l'Est — AIP vous connecte aux bons marchés, institutions et partenaires pour faire croître votre entreprise.",
  bizCtaRegister: "Enregistrer une Entreprise",
  bizCtaExplore: "Explorer les Opportunités",
  bizStat1: "Entreprises Enregistrées",
  bizStat2: "Marchés Couverts",
  bizStat3: "Jours pour Incorporer",
  bizStat4: "Taux de Réussite",
  bizCardTitle: "Enregistrement d'Entreprise",
  bizCardSubtitle: "Rwanda & Afrique de l'Est",
  bizCard1: "Dépôt au Rwanda Development Board",
  bizCard2: "Enregistrement fiscal (NIF)",
  bizCard3: "Licence commerciale & permis",
  bizCard4: "Ouverture de compte bancaire",
  bizOppTitle: "Opportunité en Direct",
  bizOppName: "Hub Pharmaceutique – Kigali",
  bizCountriesTitle: "Opérant dans",

  // Opportunities
  oppTag: "Section B",
  oppTitle1: "Opportunités",
  oppTitle2: "d'Investissement",
  oppDesc: "Opportunités d'investissement et de partenariat triées sur le volet en Afrique de l'Est. Parcourez les offres actives et manifestez un intérêt en quelques minutes.",
  oppFilterCountry: "Tous les Pays",
  oppFilterSector: "Tous les Secteurs",
  oppClear: "Effacer les filtres",
  oppCount_one: "opportunité trouvée",
  oppCount_other: "opportunités trouvées",
  oppNoResults: "Aucune opportunité ne correspond à vos filtres",
  oppNoResultsHint: "Essayez d'ajuster votre sélection de pays ou secteur",
  oppViewDetails: "Voir les Détails",
  oppInvestment: "Investissement",

  // Registration
  regTag: "Section A",
  regTitle1: "Enregistrement",
  regTitle2: "d'Entreprise",
  regDesc: "Incorporation rapide et sans tracas au Rwanda et en Afrique de l'Est. Nous gérons tout des papiers à l'approbation.",
  regRwandaNote: "Rwanda : aussi rapide que 3 jours",
  regDays: "jours",
  regHowItWorks: "Comment Ça Marche",
  regStep1Title: "Préparation des Documents",
  regStep1Desc: "Nous collectons et vérifions tous les documents d'incorporation requis.",
  regStep2Title: "Réservation du Nom",
  regStep2Desc: "Réservez votre nom d'entreprise unique auprès de l'autorité compétente.",
  regStep3Title: "Dépôt & Approbation",
  regStep3Desc: "Nous soumettons votre demande et gérons la communication avec les régulateurs.",
  regStep4Title: "Certificat Délivré",
  regStep4Desc: "Recevez votre Certificat d'Incorporation et commencez à opérer.",
  regFormTitle: "Commencez Votre Enregistrement",
  regFormName: "Nom complet",
  regFormEmail: "Adresse email",
  regFormCountry: "Pays d'Enregistrement",
  regFormSector: "Secteur Industriel",
  regFormActivity: "Activité Commerciale",
  regFormSubmit: "Commencer Maintenant",
  regFormConfidential: "Nous répondons dans les 24 heures. Vos informations sont confidentielles.",
  regFormSuccessTitle: "Demande Reçue!",
  regFormSuccessBody: "Notre équipe vous contactera dans les 24 heures pour guider vos prochaines étapes.",
  regWhyRwanda: "Pourquoi le Rwanda?",
  regRwandaStat1: "Enregistrement Moyen",
  regRwandaStat2: "Capital Minimum",
  regRwandaStat3: "Propriété Étrangère",
  regRwandaDesc: "Le Rwanda se classe #2 en Afrique pour la facilité de faire des affaires. Propriété étrangère à 100%, aucune exigence de capital minimum et un enregistrement numérique en font le meilleur point d'entrée pour l'Afrique de l'Est.",

  // Investment Portals
  portalTag: "Portails d'Investissement Officiels",
  portalTitle1: "Investir par",
  portalTitle2: "Pays",
  portalDesc: "Chaque pays dispose d'une autorité d'investissement dédiée pour vous guider à travers les réglementations, les incitations et les opportunités. Ci-dessous figurent les portails officiels avec lesquels AIP travaille dans toute la région.",
  portalCount: "7 pays · portails officiels",
  portalNeedGuidance: "Besoin d'aide pour naviguer ces portails?",
  portalGuidanceDesc: "AIP gère le processus complet — de l'enregistrement de l'investissement aux approbations réglementaires dans les 7 pays.",
  portalTalkTeam: "Parlez à Notre Équipe",
  portalVisit: "Visiter le Portail",
  portalPortal: "",
};